export default __webpack_public_path__ + "static/media/softlayer-negative.f2c54b8b.svg";